<template>
<div class="container" ref="getCertificate">
  <v-progress-linear v-if="showLoader" indeterminate></v-progress-linear>
  <div class="row pa-2">
    <v-row>
      <v-col cols="6" class="col-xs-6">
        <v-flex xs12><b><span>{{ $t('message.order.orderNumber') }} : </span></b>{{ orderDetails.ordernumber }}<b>&nbsp;&nbsp;&nbsp; <span>{{ $t('message.order.customer') }} : </span></b> {{ orderDetails.customername }}</v-flex>
        <v-flex xs12><b><span>{{ $t('message.order.date') }}</span></b> : {{ orderDetails.date | dateFormat }}</v-flex>
        <v-flex xs12><b><span>{{ $t('message.order.supplier') }}</span></b> : {{ orderDetails.supplier }}</v-flex>
      </v-col>
      <v-col cols="6" class="col-xs-6">
        <v-flex xs12 class="text-right">
          <img alt="logo" :src="`${apiURL}/logo.png`">
        </v-flex>
      </v-col>
    </v-row>
  </div>
  <div class="applySpl v-data-table elevation-1 checkboxPadding v-data-table--dense theme--light">
    <v-form autocomplete="off">
      <table dense class="table table-bordered dense_table v-data-table__wrapper">
        <thead>
          <th class="text-left" width="5%"><b>#</b></th>
          <th class="text-left" width="15%"><b>{{$t('message.order.article')}}</b></th>
          <th class="text-left" width="55%"><b>{{$t('message.customer.description')}}</b></th>
          <th class="text-left" width="20%"><b>{{$t('message.order.batchNumber')}}</b></th>
          <th class="text-left" width="5%" v-if="!hideAndShow">{{$t('message.tickets.actions')}}</th>
        </thead>
        <tbody>
          <tr v-for="(item, index) in certificates" :key="index">
            <td> {{ item.linenumber }}</td>
            <td class="pa-0 pl-2" nowrap>
              <span>{{ item.product_number }}</span>
            </td>
            <td class="pa-0 pl-2" nowrap>
              <span v-if="hideAndShow">{{ item.product_name }}</span>
              <v-text-field :placeholder="$t('message.customer.description')" v-model="item.product_name" dense hide-details full-width :class="{'applyWidth' :$vuetify.breakpoint.smAndDown }" v-else @change="changesMade()"></v-text-field>
            </td>
            <td class="pa-0 pl-2" nowrap>
              <span>{{ item.batchnumber }}</span>
            </td>
            <td class="pa-0 pl-2" nowrap v-if="!hideAndShow">
              <v-btn text icon class="ml-3" @click="deleteRowHandler(item.id, index)"><v-icon>mdi-delete</v-icon></v-btn>
            </td>
          </tr>
        </tbody>
      </table>
    </v-form>
  </div>
  <v-row>
    <v-col cols="12" sm="6" md="4">
      <v-autocomplete item-text="productName" v-model="activeProduct" item-value="id" v-if="!hideAndShow"
        :items="listOfProducts" dense autocomplete="off"
        outlined hide-details :label="$t('message.orders.addNewProduct')" :placeholder="$t('message.orders.searchForProduct')">
        <template v-slot:append>
          <v-btn fab dark x-small color="primary" class="mb-2" @click="addNewCertificateLine">
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
        </template>
      </v-autocomplete>
    </v-col>
  </v-row>
  <p class="pr-10" style="padding-top:2px">
    Sertifikat utstedt av Kilab AS.<br/>
    For internt bruk hos kunde.<br/>
  </p>
  <p class="mt-3">
    Sertifikatnr: {{ new Date().getFullYear() }}-{{ new Date().getMonth() + 1 }}-{{ orderDetails.number }}
  </p>
  <v-divider v-if="!hideAndShow"></v-divider>
  <v-card-actions v-if="!hideAndShow">
    <v-spacer></v-spacer>
    <v-btn color="success" dark @click="saveOrUpdateCertificateHandler(false)" :loading="loading" class="mr-1">{{$t('message.common.update')}}</v-btn>
    <v-btn color="primary" dark @click="saveOrUpdateCertificateHandler(true)" :loading="loading" class="mr-1">{{$t('message.common.updateAndClose')}}</v-btn>
    <v-menu offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn color="info" class="ml-3" :loading="actionLoading" dark v-bind="attrs" v-on="on">
          {{ $t('message.order.certificate') }}
        </v-btn>
      </template>
      <v-list>
        <v-list-item v-for="(item, index) in certificateOptions" @click="item.click" :key="index">
          <v-list-item-title>{{ item.text }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <v-spacer></v-spacer>
  </v-card-actions>
  <v-dialog v-model="dialog" persistent width="600">
    <v-card >
      <v-card-title class="headline grey lighten-2" primary-title> {{ $t('message.order.share') }} </v-card-title>
      <v-card-text>
        <v-form ref="sendEmailForm">
          <v-container fluid>
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field  v-model="sendEmailData.emailIds" :label="$t('message.customer.email')" type="text" :rules="$_requiredValidation"></v-text-field>
              </v-flex>
              <v-flex xs12>
                {{ $t('message.order.emailNote') }}
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions class="text-center">
        <v-spacer></v-spacer>
        <v-btn color="primary" dark @click="sendReport()" :loading="loadingSpinner"> {{ $t('message.common.ok') }}</v-btn>
        <v-btn color="error" dark @click="dialog = false, sendEmailData.emailIds = null, $refs.sendEmailForm.reset()">{{ $t('message.common.cancel') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</div>
</template>
<script>
import axios from 'axios'
import certificateReport from '@/assets/js/report/certificate'
export default {
  data () {
    return {
      currentDate: new Date(),
      orderDetails: {},
      certificateId: 0,
      certificates: [],
      selectedIndex: '',
      showLoader: false,
      loading: false,
      hideAndShow: false,
      sendEmailData: {},
      dialog: false,
      loadingSpinner: false,
      downloadLoading: false,
      listOfProducts: [],
      listOfBatchNumbers: [],
      MODULE_URL: 'certificates',
      activeProduct: '',
      orderId: this.$route.params.order_id,
      actionLoading: false
    }
  },
  computed: {
    headers () {
      return [
        { text: '#', value: 'line_number', width: '5%', sortable: false },
        { text: this.$t('message.order.article'), value: 'product_number', width: '20%', sortable: false },
        { text: this.$t('message.customer.description'), value: 'product_description', width: '55%', sortable: false },
        { text: this.$t('message.order.batchNumber'), value: 'batch_number', width: '20%', sortable: false }
      ]
    },
    apiURL () {
      return axios.defaults.imageURL
    },
    certificateOptions () {
      return [{
        text: this.$t('message.certificate.create'),
        click: this.recreateCertificate
      }, {
        text: this.$t('message.order.download'),
        click: () => this.generatePDF(`/certificates/generate_pdf/${this.orderId}`, 'file/download/')
      }, {
        text: this.$t('message.customer.email'),
        click: this.openShareDialog
      }, {
        text: this.$t('message.certificate.reCreate'),
        click: this.recreateCertificate
      }]
    }
  },
  mounted () {
    this.getOrderDetails()
    this.getOrderProducts()
    let text = this.$t('message.common.deleteMsg')
    this.$eventBus.$on('deleteSuccess', (data) => {
      if (data === 'certificateproducts') {
        this.$root.$emit('snackbar', { snackbar: true, color: 'success', text })
        this.$store.commit('hideDialog')
        this.certificates.splice(this.selectedIndex, 1)
        this.selectedIndex = ''
      }
    })
  },
  methods: {
    getOrderDetails () {
      this.showLoader = true
      this.$_executeApi('get', `certificates/${this.orderId}`).then((response) => {
        this.orderDetails = response.data
        this.getCertificateProducts(response.data.id)
      })
    },
    getCertificateProducts (id) {
      let query = {
        'expand': [{
          'select': ['id', 'number', 'name'],
          'model': 'Product',
          'on_field': 'id',
          'on_parent_field': 'productid'
        }],
        filter: `certificateid eq '${id}'`
      }
      this.$_executeApi('post', `certificateproducts/query`, query).then((response) => {
        this.certificates = response.data
        this.showLoader = false
      })
    },
    addNewCertificateLine () {
      this.changesMade()
      if (this.activeProduct) {
        let product = this.listOfProducts.find(x => x.id === this.activeProduct)
        let list = this.$formatter.cloneVariable(this.certificates)
        let numbers = []
        list.map((x) => {
          numbers.push(x.linenumber)
        })
        let getMax = Math.max(...numbers)
        this.certificates.push({
          linenumber: getMax > 0 ? getMax + 1 : 1,
          productid: product.id,
          product_name: product.name || '',
          product_number: product.number,
          batchnumber: product.batchnumber
        })
        this.activeProduct = ''
      } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.order.productNotFound') })
    },
    openShareDialog () {
      this.dialog = true
      this.sendEmailData.emailIds = this.$parent.order.ordercustomercontactdata ? this.$parent.order.ordercustomercontactdata.Email || '' : ''
    },
    saveOrUpdateCertificateHandler (isClose) {
      this.loading = true
      this.$_executeApi('post', `certificateproducts/bulk_save/${this.orderDetails.id}`, this.certificates)
        .then((response) => {
          this.$store.commit('isChangesMade', false)
          this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.common.updatedSuccess') })
          if (isClose) this.$router.push('/orders')
          else this.getOrderDetails()
        })
        .finally(() => {
          this.loading = false
        })
    },
    // Generate as PDF file
    async generatePDF (postUrl, downloadUrl, model) {
      if (!model) this.downloadLoading = true
      this.hideAndShow = true
      this.actionLoading = true
      setTimeout(async () => {
        this.hideAndShow = false
        var getBase64Content = { content: await this.getPDFContent() }
        axios.post(postUrl, getBase64Content).then((response) => {
          let fileName = response.data
          if (model) {
            model.subject = 'Kilab Certificate'
            model.filename = fileName
            axios.post(`certificates/share/${this.orderId}`, model).then((response) => {
              if (model && model.to) {
                this.loadingSpinner = false
                this.downloadLoading = false
              }
              this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.tickets.sentSuccess') })
              if (model && model.to) {
                this.dialog = false
                this.sendEmailData.emailIds = null
                this.$refs.sendEmailForm.reset()
              }
            })
              .finally(() => {
                this.actionLoading = false
              })
          } else {
            this.downloadLoading = false
            this.actionLoading = false
            window.open(`${axios.defaults.baseURL}${downloadUrl}?fileName=${fileName}`, '_blank')
          }
        })
      })
    },
    async getPDFContent () {
      let getObj = this.$formatter.cloneVariable(this.orderDetails)
      let customerLang = getObj.customerlang ? getObj.customerlang : this.$i18n.locale
      let lang = this.$i18n.messages[customerLang].message
      if (getObj) {
        let headers = [{ text: '#', value: 'linenumber' },
          { text: lang.order.article, value: 'product_number' },
          { text: lang.customer.description, value: 'product_name' },
          { text: lang.order.batchNumber, value: 'batchnumber' }
        ]
        let translationData = {
          orderNumber: lang.product.number,
          orderDate: lang.order.date,
          supplier: lang.order.supplier,
          customer: lang.order.customer
        }
        getObj.cernumber = `${new Date().getFullYear()} - ${new Date().getMonth() + 1} - ${getObj.number}`
        getObj.date = this.$_filterDate(getObj.date)
        let getBase64Content = certificateReport(headers, this.certificates, getObj, translationData)
        return getBase64Content
      }
    },
    sendReport () {
      if (this.$refs.sendEmailForm.validate()) {
        if (!this.sendEmailData.emailIds.length > 0) this.isValidEmail = true
        let getMailIDsString = this.sendEmailData.emailIds
        let listOfMailIds = getMailIDsString.split(',')
        if (listOfMailIds && listOfMailIds.length > 0) {
          for (let i = 0; i < listOfMailIds.length; i++) {
            if (listOfMailIds[i]) {
              listOfMailIds[i] = listOfMailIds[i].trim()
              if (this.validEmail(listOfMailIds[i])) this.isValidEmail = false
              else this.isValidEmail = true
            }
          }
        }
        if (!this.isValidEmail) {
          this.loadingSpinner = true
          let model = {}
          model = this.$formatter.cloneVariable(this.reportFilter)
          model = {
            to: listOfMailIds
          }
          this.generatePDF(`/certificates/generate_pdf/${this.orderId}`, 'file/download/', model)
        }
      }
    },
    recreateCertificate () {
      this.loading = true
      this.actionLoading = true
      this.$_executeApi('post', `certificates/recreate/${this.orderId}`).then((response) => {
        this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.common.savedSuccess') })
        this.getOrderDetails()
        this.loading = false
      })
        .finally(() => {
          this.actionLoading = false
        })
    },
    getOrderProducts () {
      this.$_executeApi('get', `certificateproducts/get_products/${this.orderId}`)
        .then((response) => {
          this.listOfProducts = []
          if (response.data && response.data.length > 0) {
            response.data.forEach(element => {
              element.productName = element.number ? `${element.number} - ${element.name}` : element.name
            })
            this.listOfProducts = response.data
          }
        })
    },
    deleteRowHandler (id, index) {
      if (id) {
        let ids = [id]
        let payload = { ids, url: `certificateproducts/delete_multiple`, module: 'certificateproducts' }
        this.selectedIndex = index
        this.$store.commit('showDeleteDialog', payload)
      } else {
        this.certificates.splice(index, 1)
      }
    },
    /* eslint-disable */
    validEmail: function (email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(email)
    },
    changesMade () {
      this.$store.commit('isChangesMade', true)
    }
  },
  beforeRouteLeave (to, from, next) {
    if (!this.$store.state.isChangesMade) {
      next()
    } else {
      this.$store.commit('isChangesMade', true)
      this.$store.commit('changeLostDialog', true)
    }
  },
  beforeDestroy () {
    this.$eventBus.$off('deleteSuccess')
  }
}
</script>
<style scoped>
.applyWidth {
  width: max-content;
}
table.v-table tbody td:not(:nth-child(1)) {
  padding: 0 6px;
}
.applySpl table th, td {
  border: 1px solid #80808036;
  text-align: left;
}
</style>
